(function () {
  "use strict";
  /* Corus — hero video: no src in the raw HTML any more (source[data-src]
     only), so the browser's preload scanner cannot fetch the hidden
     wrapper's video before this script runs. This assigns src + calls
     load()/play() ONLY on the wrapper actually shown for the current
     viewport, once per .hero section on the page.
     History, so nobody reintroduces an old bug:
       v1 called video.load() on whichever wrapper matched FIRST in the DOM
       (always desktop) — load() resets an already-autoplaying element and
       re-fetches it, so the hero downloaded twice.
       v2 (2026-08-29) fixed the selector to the displayed wrapper, which
       just moved the double-fetch onto the larger mobile file.
       v3 (2026-08-29) stopped calling load() at all, but both <video>
       elements still had a `src` in the raw HTML, so mobile always
       downloaded BOTH the mobile AND the desktop video regardless of JS —
       PSI 2026-08-31 confirmed 11.3MB of video fetched on a phone.
       v4 (this version, 2026-08-31): the fix has to happen in the markup,
       not just the script — sections/hero.liquid now emits
       <source data-src="..."> instead of <source src="..."> and drops the
       autoplay attribute, so an inactive wrapper's video has nothing to
       fetch until JS explicitly assigns it. Only the active wrapper ever
       gets a real src. */
  function activateHero(hero) {
    var wraps = hero.querySelectorAll(".hero__media-wrapper--desktop, .hero__media-wrapper--mobile");
    var active = null;
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.offsetParent !== null || w.getClientRects().length > 0) {
        active = w;
        break;
      }
    }
    if (!active) return;
    var video = active.querySelector("video.hero__media[data-hero-video]");
    if (!video) return;
    var sources = video.querySelectorAll("source[data-src]");
    if (!sources.length) return;
    for (var j = 0; j < sources.length; j++) {
      sources[j].setAttribute("src", sources[j].getAttribute("data-src"));
      sources[j].removeAttribute("data-src");
    }
    try {
      video.setAttribute("preload", "auto");
      video.load();
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    } catch (e) {}
  }
  function run() {
    var heroes = document.querySelectorAll(".hero");
    for (var i = 0; i < heroes.length; i++) activateHero(heroes[i]);
  }
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
})();
